export default __webpack_public_path__ + "static/media/html.e42ea231.png";